import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isHome = location.pathname === '/';

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur-sm">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-read-line text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-bold text-foreground-900 font-heading">韩国漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 7).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2 text-sm text-foreground-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="px-3 py-2 text-sm text-primary-600 font-medium hover:bg-primary-50 rounded-lg transition-colors duration-200 whitespace-nowrap"
            >
              更多分类
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors duration-200 whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/category/all"
              className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200">
            <div className="flex flex-col gap-1 pt-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setMobileOpen(false)}
                  className="px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors duration-200 whitespace-nowrap"
                >
                  <i className={`${cat.icon} mr-2`}></i>
                  {cat.name}
                </Link>
              ))}
              <hr className="my-2 border-background-200" />
              <Link
                to="/about"
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-500 hover:text-foreground-800 rounded-lg transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-information-line mr-2"></i>
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}